<template>
<div>
  <GridLocal name="filterGridProdAgreg" ref="filterGridProdAgreg" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"  v-bind:databound="dataBound" ></GridLocal>
  <div>
    <b-button v-on:click="addAll()" variant="success">Incluir todos</b-button>
    <b-button variant="danger" v-on:click="excludeAll()">Excluir todos</b-button>
  </div>
</div>
</template>

<script>
import GridLocal from '@/components/GridLocal.vue'
import BaseFilter from './BaseFilter'
export default {
  name: 'ProdAgreg',
  extends: BaseFilter,
  components: {
    GridLocal
  },
  data() {
    return {
      fieldName: 'prodaggreg_id',
      fieldLabel: 'Prodagreg',
      gridRef: 'filterGridProdAgreg',
      preload: [{
        field: 'top10_id',
        api: 'top10/lst'
      }, {
        field: 'brand_id',
        api: 'brands/lst'
      }, {
        field: 'product_category_id',
        api: 'product_categories/lst'
      }],
      schemaModelFields: {},
      url: 'prodagregs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }, {
        field: 'top10_id',
        title: 'Top UFS',
        width: '200px'
      }, {
        field: 'brand_id',
        title: 'Brand',
        width: '200px'
      }, {
        field: 'product_category_id',
        title: 'Category',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProdAgregFilter.vue?9f87d032